/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkExperience } from '../../models/work-experience';

export interface CreateWorkExperience$Params {
  profileId: string;
      body?: WorkExperience
}

export function createWorkExperience(http: HttpClient, rootUrl: string, params: CreateWorkExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkExperience>> {
  const rb = new RequestBuilder(rootUrl, createWorkExperience.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkExperience>;
    })
  );
}

createWorkExperience.PATH = '/studentprofile/{profileId}/workexperience';
